import { Component, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

import Swal from 'sweetalert2';

import {
  AuthService
} from '../../../service/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,

  imports: [
    CommonModule,
    FormsModule
  ],

  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {

  email = '';
  senha = '';

  carregando = false;

  constructor(
    private authService: AuthService,
    private router: Router, private cdr: ChangeDetectorRef
  ) {}

  entrar(): void {

    if (!this.email || !this.senha) {

      Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Informe o e-mail e a senha.'
      });

      return;
    }

    this.carregando = true;

    this.cdr.detectChanges();

    this.authService
      .login({
        email: this.email,
        senha: this.senha
      })
      .subscribe({

        next: (resposta) => {

          localStorage.setItem(
            'token',
            resposta.token
          );

          localStorage.setItem(
            'adminNome',
            resposta.nome
          );

          localStorage.setItem(
            'adminEmail',
            resposta.email
          );

          localStorage.setItem(
            'adminTipo',
            resposta.tipo
          );

          this.carregando = false;

          this.cdr.detectChanges();

          this.router.navigate([
            '/admin/dashboard'
          ]).then((navegou) => {

          });

        },

        error: (erro) => {

          this.carregando = false;

          this.cdr.detectChanges();

          Swal.fire({
            icon: 'error',
            title: 'Login inválido',
            text: 'E-mail ou senha incorretos.'
          });

        }

      });
  }
}
